import { forwardRef } from "react";
import InputField from "./InputField.js";

const PasswordField = forwardRef(function (props, ref) {
  return <InputField type="password" {...props} />;
});
PasswordField.displayName = "PasswordField";

export default PasswordField;
